// ======================================================================
// File: src/modules/ppe/transport/services/transportService.js
// Module: PPE → Transport
// Purpose:
//   API communication layer for Transport Management
//   Pattern aligned with fmsService.js
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

// ----------------------------------------------------------------------
// BASE URL (Must match backend blueprint)
// ----------------------------------------------------------------------
const BASE_URL = "/api/ppe/transport";

const transportService = {

  // ==============================================================
  // TRANSPORT REQUEST
  // ==============================================================

  getTransportList: async (params = {}) => {
    const res = await axiosClient.get(`${BASE_URL}/requests`, {
      params,
    });
    return res.data;
  },

  getTransportById: async (id) => {
    const res = await axiosClient.get(`${BASE_URL}/requests/${id}`);
    return res.data;
  },

  createTransport: async (payload) => {
    const res = await axiosClient.post(
      `${BASE_URL}/requests`,
      payload
    );
    return res.data;
  },
  updateTransport: async (id, payload) => {
  const res = await axiosClient.put(
    `${BASE_URL}/requests/${id}`,
    payload
  );
  return res.data;
},


  closeTransport: async (id) => {
    const res = await axiosClient.post(
      `${BASE_URL}/requests/${id}/close`
    );
    return res.data;
  },

  // ✅ Assign Transporter (Booking Step)
  assignTransporter: async (transportId, transporter_bp_id) => {
    const res = await axiosClient.post(
      `${BASE_URL}/requests/${transportId}/assign-transporter`,
      { transporter_bp_id }
    );
    return res.data;
  },


  // ==============================================================
  // VEHICLES
  // ==============================================================

  addVehicle: async (payload) => {
    const res = await axiosClient.post(
      `${BASE_URL}/vehicles`,
      payload
    );
    return res.data;
  },

  markPickup: async (vehicleId) => {
    const res = await axiosClient.post(
      `${BASE_URL}/vehicles/${vehicleId}/pickup`
    );
    return res.data;
  },

  markDelivery: async (vehicleId) => {
    const res = await axiosClient.post(
      `${BASE_URL}/vehicles/${vehicleId}/deliver`
    );
    return res.data;
  },

  // --------------------------------------------------------------
  // ✅ Lifecycle Aliases (used by TransportDetail screen)
  // --------------------------------------------------------------
  markVehiclePickup: async (vehicleId) => {
    return transportService.markPickup(vehicleId);
  },

  markVehicleDelivery: async (vehicleId) => {
    return transportService.markDelivery(vehicleId);
  },


  // ==============================================================
  // PAYMENTS
  // ==============================================================

  addPayment: async (payload) => {
    const res = await axiosClient.post(
      `${BASE_URL}/payments`,
      payload
    );
    return res.data;
  },


  // ==============================================================
  // LOOKUPS
  // ==============================================================

  // ✅ Transporter lookup (same pattern as PO vendor search)
  searchTransporters: async (query) => {
    const res = await axiosClient.get(
      `${BASE_URL}/transporters/search`,
      {
        params: { q: query },
      }
    );
    return res.data;
  },

  
  // Tax classification lookup (SAC)
  getTaxClassifications: async (type = "SAC") => {
    const res = await axiosClient.get(
      "/api/ppe/masters/tax-classifications/lookup",
      {
        params: { type },
      }
    );
    return res.data;
  },
  
  
  
  searchPurchaseOrders: async (query) => {
    const res = await axiosClient.get(
      `${BASE_URL}/purchase-orders/search`,
      {
        params: { q: query },
      }
    );
    return res.data;
  },


};

export default transportService;
